import { useContext, useState } from "react";
import { OrgIdContext } from "../../store/orgId_context";
import classes from "./addCustomerElements.module.scss";
import LoadingDots from "../UI/LoadingDots";
import { Col, Container, Row } from "react-bootstrap";
import { ReactComponent as CopyBtn } from "../../assets/copy.svg";

const UsersIds = ({loading, userData, ...props}) => {
    const [copied,setCopied] =  useState();
    const { sessionInfo } =useContext(OrgIdContext);

    const onIdClick = (Id) =>{
        navigator.clipboard.writeText(Id);

        setCopied(Id);
        setTimeout(() => {
            setCopied(false);
        }, 1500);
    }
    return(
        <>
        {loading && <LoadingDots/>}
        
        {userData && <>
            <Container>
                <Row style={{textAlign:"center", borderBottom:"1px solid #005c8b"}}>
                    <Col>Username</Col>
                    <Col>Name</Col>
                    <Col className="col-6">Id</Col>
                </Row>
            {userData.map(item => {
                return (<>
                    <Row style={{paddingTop: "1rem"}}>
                        <Col>{item.UserName}</Col>
                        <Col>{item.Name}</Col>
                        <Col className={`${classes["orgIdText"]} col-6`} onClick={() => onIdClick(item.Id)}>
                            {item.Id}
                            <CopyBtn height="15" fill="#00436D" />
                        </Col>
                    </Row>
                    {copied===item.Id && 
                    <Row>
                        <Col className="col-8"></Col>
                        <Col>Copied!</Col>
                    </Row>}
                    </>
                )
            })}
            </Container>
        </>}
        {/* <div className={classes["orgIdText"]} {...props}>
            Your user Id is: 
            <span className={classes["orgId"]} onClick={onIdClick}>{sessionInfo?.User?.Id}</span>
            {copied && <span style={{paddingLeft:"1rem"}}>Copied!</span>}
        </div> */}
        </>
    )
}

export default UsersIds;